/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import MapView from '@arcgis/core/views/MapView';
import WebMap from '@arcgis/core/WebMap';
import {Results} from '@ion/core/src/services/GroupProperties';
import {GenericObject, HVSRecord} from '@ion/core/src/types/entities';
import {BoundaryMode, ColorModeEnum, CreateGeoFenceTypeEnum} from '@ion/dls/src/types/types';

/**
 * History Default Input Events
 */
export enum HistoryDefaultInputsEnum {
  input1 = 'input1',
  input2 = 'input2',
  input3 = 'input3',
  input4 = 'input4',
  input5 = 'input5',
  input6 = 'input6',
  input7 = 'input7'
};

export interface BoundaryLayerProps {
  boundary?: number[][];
}

export interface BoundaryPanelProps {
  boundary?: number[][];
  boundaryMode?: BoundaryMode;
  boundaryPanelOpen: boolean;
  selectedBoundaryTool: CreateGeoFenceTypeEnum
  onApplyBoundary: Function;
  toggleShowBoundaryPanel: Function;
  vicinitySearchprops?: GenericObject;
}

export interface MapProps {
  webMapId: Results;
  basemap: string;
  storeTrackingExtent?: Function;
  onResetSelectedAsset?: Function;
  onMapViewChange?: Function;
  setOperationalLayers?: Function;
  onToggleClustering?: Function;
  disableZoomingDblClick?: boolean;
}

export interface FindNearbyProps {
  findNearbyDistance?: number;
  isFindNearbyPanelActive?: Boolean;
  setFindNearbyPanelActive?: Function;
  setFindNearbyDistance?: Function;
}

export interface MapViewProps {
  map?: WebMap;
  initialExtent?: GenericObject
  containerRef?: React.RefObject<HTMLDivElement>;
  disableZoomingDblClick?: boolean;
  ui?: {
    components: any[]
  },
  constraints?: {
    minZoom: number,
    rotationEnabled: boolean
  },
  customExtent?: any,
  popup?: {
    actions: [],
    highlightEnabled: boolean,
    spinnerEnabled: boolean,
    dockOptions: {
      breakpoint: boolean
    }
  },
  highlightOptions?: {
    haloColor: number[],
    fillOpacity: number
  }
}

export interface MapContainerProps {
  map?: WebMap;
  view?: MapView;
  isTripServicesEnabled?: boolean;
  clusterColor?: ColorModeEnum;
  initialExtent?: GenericObject;
  queryParams?: GenericObject;
  assetsRoutesHistory?: GenericObject;
  onEventHovered?: Function;
  onSetView?: Function;
  onLayerDrawn?: Function;
  hoveredEvent?: HVSRecord;
  timeline?: any;
}

// Map widget's portal identifiers...
export enum MapWidgetIdentifiers {
  SCI_DEVICE_POPUP = 'sci-device-popup',
  BASEMAP_GALLERY = 'basemap-gallery-component_portal',
  MAP_LAYER_CHOOSER = 'map-layer-chooser_portal',
  MAP_SEARCH_VIEW = 'map-search-view_portal',
  MAP_CREATE_GEOFENCES = 'map-create-geofences_portal',
  MAP_CREATE_BOUNDARY = 'map-create-boundary_portal',
  SAVE_MAP_VIEW_TOOL = 'save-map-view-tool_portal',
  MAP_LIVE_HISTORY = 'map-liveHistory-container_portal',
  NEAR_BY_PANEL = 'map-findNearby-container',
  CONTEXT_MENU = 'map-context-menu_portal'
};
